<template>
  <b-modal
    ref="modal"
    size="lg"
    hide-footer
    title="ตารางแพทย์"
    body-class="doctor-schedule-finder-body"
  >
    <div class="dsf-toolbar">
      <multiselect
        class="dsf-search"
        v-model="selectedDoctorObjects"
        :options="doctorOptions"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        placeholder="ค้นหา / เลือกแพทย์ (เลือกได้หลายคน)"
        label="text"
        track-by="value"
        selectLabel=""
        selectedLabel=""
        deselectLabel=""
      >
        <span slot="noResult">ไม่พบแพทย์</span>
      </multiselect>
      <div class="dsf-monthnav">
        <b-button size="sm" variant="light" @click="stepMonth(-1)">‹</b-button>
        <span class="dsf-monthlabel">{{ monthLabel }}</span>
        <b-button size="sm" variant="light" @click="stepMonth(1)">›</b-button>
      </div>
    </div>

    <DoctorMonthOverview
      :year="viewYear"
      :month="viewMonth"
      :members="members"
      :doctors="doctors"
      :highlight-doctor-ids="selectedDoctorIds"
      :loading="loading"
      @day-click="onDayClick"
    />

    <p class="dsf-legend">
      จุดสี = หมอที่ลงตรวจวันนั้น (รวมวันลา/ลงเพิ่มแล้ว) · ชี้ค้างเพื่อดูชื่อ ·
      คลิกวันเพื่อไปดูคิววันนั้น
    </p>
  </b-modal>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
import Multiselect from "vue-multiselect";
import DoctorMonthOverview from "@/components/workingHours/DoctorMonthOverview.vue";

const TH_MONTHS = [
  "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
  "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",
];

export default {
  name: "DoctorScheduleFinder",
  components: { DoctorMonthOverview, Multiselect },
  props: {
    // normalized doctors: [{ branchMemberId, name, color }]
    doctors: { type: Array, default: () => [] },
    initialDate: { type: String, default: null }, // YYYY-MM-DD
  },
  data() {
    const anchor = this.initialDate ? moment(this.initialDate) : moment();
    return {
      viewYear: anchor.year(),
      viewMonth: anchor.month() + 1,
      selectedDoctorObjects: [], // [{ text, value }] from multiselect
      loading: false,
      members: [],
      monthCache: {}, // "YYYY-M" -> members[]
    };
  },
  computed: {
    monthLabel() {
      return `${TH_MONTHS[this.viewMonth - 1]} ${this.viewYear + 543}`;
    },
    monthKey() {
      return `${this.viewYear}-${this.viewMonth}`;
    },
    // options for the doctor multiselect, keyed by branchMemberId
    doctorOptions() {
      return this.doctors.map((d) => ({
        text: d.name,
        value: d.branchMemberId,
      }));
    },
    selectedDoctorIds() {
      return this.selectedDoctorObjects.map((o) => o.value);
    },
  },
  methods: {
    ...mapActions({
      fetchBranchSchedule: "moduleWorkingHours/fetchBranchSchedule",
    }),
    show() {
      const anchor = this.initialDate ? moment(this.initialDate) : moment();
      this.viewYear = anchor.year();
      this.viewMonth = anchor.month() + 1;
      this.selectedDoctorObjects = [];
      this.$refs.modal.show();
      this.load();
    },
    stepMonth(delta) {
      const next = moment(`${this.viewYear}-${this.viewMonth}-01`, "YYYY-M-DD").add(
        delta,
        "month"
      );
      this.viewYear = next.year();
      this.viewMonth = next.month() + 1;
      this.load();
    },
    async load() {
      const key = this.monthKey;
      if (this.monthCache[key]) {
        this.members = this.monthCache[key];
        return;
      }
      const start = moment(`${this.viewYear}-${this.viewMonth}-01`, "YYYY-M-DD");
      this.loading = true;
      try {
        const members = await this.fetchBranchSchedule({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          from: start.format("YYYY-MM-DD"),
          to: start.clone().endOf("month").format("YYYY-MM-DD"),
        });
        this.$set(this.monthCache, key, members);
        // Guard against a stale response after the user paged months.
        if (this.monthKey === key) this.members = members;
      } finally {
        this.loading = false;
      }
    },
    onDayClick(dateStr) {
      this.$emit("select-date", dateStr);
      this.$refs.modal.hide();
    },
  },
};
</script>

<style scoped>
.dsf-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}
.dsf-search {
  flex: 1;
}
.dsf-monthnav {
  display: flex;
  align-items: center;
  gap: 6px;
}
.dsf-monthlabel {
  font-weight: 600;
  font-size: 14px;
  min-width: 130px;
  text-align: center;
}
.dsf-legend {
  font-size: 11px;
  color: #888;
  margin: 12px 0 0;
}
</style>
